import { combineReducers } from 'redux';

import {
  SET_PROCEDURE_FILTERS,
  RESET_PROCEDURE_FILTERS,
  SET_PROCEDURE_GRID_SORT_CRITERIA,
} from './actionTypes';

const procedureFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const procedureGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const procedureFiltersReducer = (
  state = procedureFiltersInitialState,
  { type = '', filters = { ...procedureFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_PROCEDURE_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_PROCEDURE_FILTERS:
      return {
        ...state,
        ...procedureFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentProcedureGridSortCriteriaReducer = (
  state = procedureGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...procedureGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_PROCEDURE_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const procedureReducer = combineReducers({
  procedureFilters: procedureFiltersReducer,
  procedureGridSortCriteria: currentProcedureGridSortCriteriaReducer,
});

export { procedureReducer, procedureFiltersInitialState, procedureGridSortCriteriaInitialState };
